export default __webpack_public_path__ + "static/media/25083005.2046c0bf.jpg";